<template>
    <va-edit-layout>
        <FbaInventory-form
            :id="id"
            :title="title"
            :item="item"
        ></FbaInventory-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
